/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pt-option-group.vue?vue&type=template&id=3006a588&"
import script from "./pt-option-group.vue?vue&type=script&lang=js&"
export * from "./pt-option-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports